<template>
  <div>
    <button
      class="boss-button"
      data-test="button-download"
      @click="onDownloadClick"
    >
      <img
        src="../../assets/images/icon-download.svg"
        alt
      >
      <span>PDFダウンロード</span>
    </button>
  </div>
</template>

<script>
import { downloadPDF } from '@/lib/download'

export default {
  props: {
    entryIds: {
      type: Array,
      required: true
    }
  },
  methods: {
    onDownloadClick () {
      downloadPDF(this.entryIds)
    }
  }
}
</script>
